export default __webpack_public_path__ + "static/media/hilden_light.63721c27.png";